import Apps from '@material-ui/icons/Apps';
import DashboardIcon from '@material-ui/icons/Dashboard';
import {
  AttachMoney,
  LocalShipping,
  PhoneAndroid,
  ShoppingCart,
  SupervisorAccount,
  Event,
  AccountBalance,
  Settings,
  Receipt,
  MonetizationOn,
  Print,
  LocalAtm,
  Assessment,
} from '@material-ui/icons';

const sidebarConfig = [
  {
    title: 'Seguridad',
    children: [
      {
        path: '/auth/login',
        title: 'Login',
      },
      {
        path: 'login-page',
        title: 'Iniciar sesión',
      },
      {
        path: 'register-page',
        title: 'Nuevos clientes',
      },
      {
        path: '/auth/lock-screen-page',
        title: 'Bloquear',
      },
      {
        path: 'perfil',
        title: 'Perfil',
      },
      {
        path: 'actualizar-password',
        title: 'Actualizar contraseña',
      },
      {
        path: 'user-page',
        title: 'Perfil del usuario',
      },
      {
        path: 'logout-page',
        title: 'Cerrar sesión',
      },
      {
        path: 'logout',
        title: 'Cerrar sesión',
      },
      {
        path: 'error-page',
        title: 'Página error',
      },
      {
        path: '*',
      },
    ],
  },
  {
    title: 'Admin',
    children: [
      {
        title: 'Dashboard',
        path: '/admin/dashboard',
        icon: DashboardIcon,
      },
      {
        title: 'Socio negocio',
        icon: SupervisorAccount,
        children: [
          {
            title: 'Datos Maestros',
            children: [
              {
                path: '/admin/socio-negocio/datos-maestros/proveedor',
                title: 'Proveedor',
              },
              {
                path: '/admin/socio-negocio/datos-maestros/clientes',
                title: 'Cliente',
              },
              {
                path: '/admin/socio-negocio/datos-maestros/control-muebles',
                title: 'Control de muebles',
              },
              {
                path: '/admin/socio-negocio/datos-maestros/incompletos',
                title: 'Socios Incompletos',
              },
              {
                path: '/admin/socio-negocio/datos-maestros/giro-negocio',
                title: 'Giro de negocio',
              },
              {
                path: '/admin/socio-negocio/datos-maestros/termino-pago',
                title: 'Término Pago',
              },
              {
                path: '/admin/socio-negocio/datos-maestros/tipo-documento',
                title: 'Tipo documento',
              },
              {
                path: '/admin/socio-negocio/datos-maestros/muebles',
                title: 'Muebles',
              },
              {
                path: '/admin/socio-negocio/datos-maestros/categorias-muebles',
                title: 'Categorías de muebles',
              },
              {
                path: '/admin/socio-negocio/datos-maestros/categorias-muebles-venta',
                title: 'Rango venta de mueble',
              },
            ],
          },
          {
            title: 'Consultas',
            children: [
              {
                path: '/admin/socio-negocio/consultas/clientes-creados',
                title: '_Clientes',
              },
              {
                path: '/admin/socio-negocio/consultas/inactivados',
                title: 'Clientes Inactivados',
              },
              {
                path: '/admin/socio-negocio/consultas/reactivados',
                title: 'Clientes Reactivados',
              },
              {
                path: '/admin/socio-negocio/consultas/clientes-mesa-activaciones',
                title: 'Clientes Mesa Activaciones',
              },
            ],
          },
        ],
      },
      {
        title: 'Artículos',
        icon: Apps,
        children: [
          {
            title: 'Operaciones',
            children: [
              {
                path: '/admin/articulos/operaciones/promociones',
                title: 'Promociones',
              },
              {
                path: '/admin/articulos/operaciones/promociones-retenidas',
                title: 'Promocion Retenidas',
              },
              {
                path: '/admin/articulos/operaciones/combos',
                title: 'Combos',
              },
              {
                path: '/admin/articulos/operaciones/stock-bonificacion',
                title: 'Stock Bonificación',
              },
              {
                path: '/admin/articulos/operaciones/proveedor-giro',
                title: 'Proveedor Cliente',
              },
              {
                path: '/admin/articulos/operaciones/productos-infaltables',
                title: 'Productos Infaltables',
              },
              {
                path: '/admin/articulos/operaciones/precios-retenidos',
                title: 'Precios retenidos',
              },
            ],
          },
          {
            title: 'Datos maestros',
            children: [
              {
                path: '/admin/articulos/datos-maestros/productos',
                title: 'Productos',
              },
              {
                path: '/admin/articulos/datos-maestros/stocks',
                title: 'Stocks',
              },
              {
                path: '/admin/articulos/datos-maestros/precios',
                title: 'Consulta precios',
              },
              {
                path: '/admin/articulos/datos-maestros/igv-precios',
                title: 'Precios Igv',
              },
              {
                path: '/admin/articulos/datos-maestros/lista-precios',
                title: 'Lista precios',
              },
              {
                path: '/admin/articulos/datos-maestros/escala-descuento',
                title: 'Descuento Escalado',
              },
              {
                path: '/admin/articulos/datos-maestros/regla-descuento',
                title: 'Regla Descuento',
              },
              {
                path: '/admin/articulos/datos-maestros/almacen',
                title: 'Almacén',
              },
              {
                path: '/admin/articulos/datos-maestros/portfolio',
                title: 'Portafolio',
              },
              {
                path: '/admin/articulos/datos-maestros/marca',
                title: 'Marca',
              },
              {
                path: '/admin/articulos/datos-maestros/categorias',
                title: 'Categorías',
              },
              {
                path: '/admin/articulos/datos-maestros/lineas',
                title: 'Líneas',
              },
              {
                path: '/admin/articulos/datos-maestros/familias',
                title: 'Familias',
              },
              {
                path: '/admin/articulos/datos-maestros/sub-familias',
                title: 'SubFamilias',
              },
              {
                path: '/admin/articulos/datos-maestros/manufactura',
                title: 'Manufactura',
              },
            ],
          },
          {
            title: 'Consultas',
            children: [
              {
                path: '/admin/articulos/consultas/margenes-negativos',
                title: 'Margenes negatívos',
              },
              {
                path: '/admin/articulos/consultas/stock-disponible',
                title: 'Stock disponible',
              },
              {
                path: '/admin/articulos/consultas/pedidos-por-promocion',
                title: 'Pedidos por promoción',
              },
              {
                path: '/admin/articulos/consultas/promociones-con-bajo-stock',
                title: 'Promociones con bajo stock',
              },
            ],
          },
        ],
      },
      {
        title: 'Inventario',
        icon: Receipt,
        children: [
          {
            title: 'Datos maestros',
            children: [
              {
                path: '/admin/inventario/datos-maestros/lista-materiales',
                title: 'Lista de materiales',
              },
            ],
          },
          {
            title: 'Operaciones',
            children: [
              {
                path: '/admin/inventario/operaciones/transferencia',
                title: 'Transferencia',
              },
              {
                path: '/admin/inventario/operaciones/conversiones',
                title: 'Conversiones',
              },
              {
                path: '/admin/inventario/operaciones/entradas',
                title: 'Entradas',
              },
              {
                path: '/admin/inventario/operaciones/salidas',
                title: 'Salidas',
              },
              {
                path: '/admin/inventario/operaciones/devoluciones',
                title: 'Devoluciones',
              },
              {
                path: '/admin/inventario/operaciones/malogrados',
                title: 'Malogrados',
              },
            ],
          },
          {
            title: 'Toma de inventario',
            children: [
              {
                path: '/admin/inventario/toma-inventario/responsables-inventario',
                title: 'Encargados inventario',
              },
              {
                path: '/admin/inventario/toma-inventario/registro-inventario',
                title: 'Registro inventario',
              },
              {
                path: '/admin/inventario/toma-inventario/registro-por-vencer',
                title: 'Productos por vencer',
              },
              {
                path: '/admin/inventario/toma-inventario/entradas-inventario',
                title: 'Entradas Inventario',
              },
              {
                path: '/admin/inventario/toma-inventario/salidas-inventario',
                title: 'Salidas Inventario',
              },
            ],
          },
        ],
      },
      {
        title: 'Compras',
        icon: ShoppingCart,
        children: [
          {
            title: 'Operaciones',
            children: [
              {
                path: '/admin/compras/operaciones/importaciones',
                title: 'Entrada Mercadería XML',
              },
              {
                path: '/admin/compras/operaciones/factura',
                title: 'Entrada Mercadería Manual',
              },
              {
                path: '/admin/compras/operaciones/factura-proveedores',
                title: 'Factura Proveedores',
              },
              {
                path: '/admin/compras/operaciones/factura-compras',
                title: 'Factura Mercadería',
              },
              {
                path: '/admin/compras/operaciones/nota-credito',
                title: 'Nota crédito Compras',
              },
              {
                path: '/admin/compras/operaciones/nota-debito',
                title: 'Nota débito Compras',
              },
              {
                path: '/admin/compras/operaciones/diferencia-precios',
                title: 'Diferencia Precios',
              },
              {
                path: '/admin/compras/operaciones/orden-compra',
                title: 'Orden de Compra',
              },
            ],
          },
          {
            title: 'Datos maestros',
            children: [
              {
                path: '/admin/compras/datos-maestros/cuenta',
                title: 'Cuenta',
              },
              {
                path: '/admin/compras/datos-maestros/concepto',
                title: 'Concepto',
              },
              {
                path: '/admin/compras/datos-maestros/centro-costo',
                title: 'Centro costo',
              },
              {
                path: '/admin/compras/datos-maestros/sire',
                title: 'Compras SIRE',
              },
            ],
          },
          {
            title: 'Consultas',
            children: [
              {
                path: '/admin/compras/consultas/ultimos-precios',
                title: 'Últimos precios de compra',
              },
            ],
          },
        ],
      },
      {
        title: 'Ventas',
        icon: AttachMoney,
        children: [
          {
            title: 'Operaciones',
            children: [
              {
                path: '/admin/ventas/operaciones/venta-web',
                title: 'Venta web',
              },
              {
                path: '/admin/ventas/operaciones/aprobados-regla',
                title: 'Aprobados por regla',
              },
              {
                path: '/admin/ventas/operaciones/nota-credito',
                title: 'Nota crédito',
              },
              {
                path: '/admin/ventas/operaciones/nota-credito-sobrantes',
                title: 'NC - Sobrantes',
              },
              {
                path: '/admin/ventas/operaciones/pedidos-retenidos',
                title: 'Pedidos Retenidos Móvil',
              },
              {
                path: '/admin/ventas/operaciones/pedidos-retenidos/web',
                title: 'Pedidos Retenidos Web',
              },
              {
                path: '/admin/ventas/operaciones/pedidos-comprometidos',
                title: 'Pedidos comprometidos',
              },
              {
                path: '/admin/ventas/operaciones/pedidos',
                title: 'Pedidos programación',
              },
              {
                path: '/admin/ventas/operaciones/pedidos-diarios',
                title: 'Pedidos diarios',
              },
              {
                path: '/admin/ventas/operaciones/productos-vendidos',
                title: 'Productos vendidos',
              },
              {
                path: '/admin/ventas/operaciones/productos-comprometidos',
                title: 'Productos comprometidos',
              },
              {
                path: '/admin/ventas/operaciones/buscar-documento',
                title: 'Buscar documento',
              },
            ],
          },
          {
            path: 'datos-maestros',
            title: 'Datos maestros',
            children: [
              {
                path: '/admin/ventas/datos-maestros/supervisor',
                title: 'Supervisor',
              },
              {
                path: '/admin/ventas/datos-maestros/vendedores',
                title: 'Vendedores',
              },
              {
                path: '/admin/ventas/datos-maestros/mesa',
                title: 'Mesa',
              },
              {
                path: '/admin/ventas/datos-maestros/cliente-mesa',
                title: 'Cliente mesa',
              },
              {
                path: '/admin/ventas/datos-maestros/carteras',
                title: 'Carteras',
              },
              {
                path: '/admin/ventas/datos-maestros/cartera-mesa',
                title: 'Cartera mesa',
              },
              {
                path: '/admin/ventas/datos-maestros/cartera-diaria',
                title: 'Cartera diaria',
              },
              {
                path: '/admin/ventas/datos-maestros/rutas',
                title: 'Rutas',
              },
              {
                path: '/admin/ventas/datos-maestros/capas',
                title: 'Capas',
              },
              {
                path: '/admin/ventas/datos-maestros/agrupamiento-de-capas',
                title: 'Agrupamiento de capas',
              },
              {
                path: '/admin/ventas/datos-maestros/zonas',
                title: 'Zonas',
              },
              {
                path: '/admin/ventas/datos-maestros/cliente-ruta',
                title: 'Cliente ruta',
              },
              {
                path: '/admin/ventas/datos-maestros/fuerza-venta',
                title: 'Fuerza venta',
              },
              {
                path: '/admin/ventas/datos-maestros/dia-visita',
                title: 'Día visita',
              },
              {
                path: '/admin/ventas/datos-maestros/cuota',
                title: 'Cuota',
              },
              {
                path: '/admin/ventas/datos-maestros/sire',
                title: 'Ventas SIRE',
              },
            ],
          },
          {
            path: 'cuotas',
            title: 'Cuota proveedor',
            children: [
              {
                path: '/admin/ventas/cuotas/proveedores',
                title: 'Cuota',
              },
              {
                path: 'cuotas-Prov',
                title: 'Proveedor',
                children: [
                  {
                    path: 'winter',
                    title: 'Winter',
                    children: [
                      {
                        path: '/admin/ventas/cuotas/proveedores/winter/cuota-cliente',
                        title: 'Cuotas Clientes',
                      },
                      {
                        path: '/admin/ventas/cuotas/proveedores/winter/cuota-vendedor',
                        title: 'Cuotas Vendedores',
                      },
                      {
                        path: '/admin/ventas/cuotas/proveedores/winter/cobertura-referencia',
                        title: 'Cobertura Referencia',
                      }
                    ],
                  },
                  {
                    path: 'colgate',
                    title: 'Colgate',
                    children: [
                      {
                        path: '/admin/ventas/cuotas/proveedores/colgate/coverage',
                        title: 'Coberturas',
                      },
                      {
                        path: '/admin/ventas/cuotas/proveedores/colgate/periods',
                        title: 'Periodos',
                      },
                      {
                        path: '/admin/ventas/cuotas/proveedores/colgate/cuota-compra',
                        title: 'Cuota de compras',
                      },
                      {
                        path: '/admin/ventas/cuotas/proveedores/colgate/cuota-categoria',
                        title: 'Cuota de categorias',
                      },
                      {
                        path: '/admin/ventas/cuotas/proveedores/colgate/cuota-grupo',
                        title: 'Cuota de grupo',
                      },
                    ],
                  },
                  {
                    path: 'softys',
                    title: 'Softys',
                    children: [
                      {
                        path: '/admin/ventas/cuotas/proveedores/softys/quota-category',
                        title: 'Cuota Categoria',
                      },
                    ],
                  },
                  {
                    path: 'google-form',
                    title: 'Formulario de google',
                    children: [
                      {
                        path: '/admin/ventas/cuotas/proveedores/google-form/supervisor',
                        title: 'Supervisores',
                      },
                      {
                        path: '/admin/ventas/cuotas/proveedores/google-form/diccionario',
                        title: 'Diccionario',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: 'comision',
            title: 'Comision',
            children: [
              {
                path: 'trabajo-campo',
                title: 'Trabajo de campo',
                children: [
                  {
                    path: '/admin/ventas/comision/trabajo-campo/supervisor',
                    title: 'Supervisores',
                  },
                  {
                    path: '/admin/ventas/comision/trabajo-campo/diccionario',
                    title: 'Diccionario',
                  },
                ],
              },
              {
                path: 'regla-parametro',
                title: 'Reglas Parametros',
                children: [
                  {
                    path: '/admin/ventas/comision/regla-parametro/supervisor-parametro',
                    title: 'Supervisor Parametro',
                  },
                  {
                    path: '/admin/ventas/comision/regla-parametro/bonos',
                    title: 'Bonos Venta',
                  },
                  {
                    path: '/admin/ventas/comision/regla-parametro/colores',
                    title: 'Bonos Colores',
                  },
                  {
                    path: '/admin/ventas/comision/regla-parametro/commissions',
                    title: 'Comisiones',
                  },
                  {
                    path: '/admin/ventas/comision/regla-parametro/group-commission',
                    title: 'Grupo Comisiones',
                  },
                  {
                    path: '/admin/ventas/comision/regla-parametro/type-worker',
                    title: 'Tipo Trabajadores',
                  },
                  {
                    path: '/admin/ventas/comision/regla-parametro/bono-zone',
                    title: 'Bono Zonas',
                  },
                ],
              },
            ],
          },
          {
            path: 'incentivos',
            title: 'Incentivos',
            children: [
              {
                path: 'colgate',
                title: 'Colgate',
                children: [
                  {
                    path: '/admin/ventas/incentivos/colgate/cuotas-incentivos',
                    title: 'Cuotas Colgate',
                  },
                  {
                    path: '/admin/ventas/incentivos/colgate/reglas',
                    title: 'Reglas',
                  },
                  {
                    path: '/admin/ventas/incentivos/colgate/rango-reglas',
                    title: 'Rango de reglas',
                  },
                ],
              },
              {
                path: '/admin/ventas/incentivos/tipo-incentivo',
                title: 'Tipos de incentivos',
              },
              {
                path: 'unilever',
                title: 'Unilever',
                children: [
                  {
                    path: '/admin/ventas/incentivos/unilever/grupo-incentivo',
                    title: 'Grupos de incentivos',
                  },
                  {
                    path: '/admin/ventas/incentivos/unilever/cuota-unilever-vendedor',
                    title: 'Cuota vendedor',
                  },
                  {
                    path: '/admin/ventas/incentivos/unilever/unilever-supervisor',
                    title: 'Supervisores',
                  },
                ],
              },
            ],
          },
          {
            path: 'consultas',
            title: 'Consultas',
            children: [
              {
                path: '/admin/ventas/consultas/fuera-de-ruta-cartera',
                title: 'Fuera de ruta cartera',
              },
            ],
          },
        ],
      },
      //bancos
      {
        title: 'Bancos',
        icon: AccountBalance,
        children: [
          {
            title: 'Datos Maestros',
            children: [
              {
                path: '/admin/bancos/datos-maestros2/extracto-bancario',
                title: 'Extracto bancario',
              },
            ],
          },
          {
            title: 'Operaciones',
            children: [
              {
                path: '/admin/bancos/operaciones/cierre-de-caja',
                title: 'Cierre de caja',
              },
              {
                path: '/admin/bancos/operaciones/pago-recibidos',
                title: 'Pagos recibidos',
              },
              {
                path: '/admin/bancos/operaciones/pagos-efectuados',
                title: 'Pagos efectuados',
              },
              {
                path: '/admin/bancos/operaciones/listado-cuentas',
                title: 'Listado de cuentas',
              },
              {
                path: '/admin/bancos/operaciones/depositos',
                title: 'Depositos',
              },
              {
                path: '/admin/bancos/operaciones/aplicar-nc',
                title: 'Aplicar NC',
              },
              {
                path: '/admin/bancos/operaciones/reconciliacion',
                title: 'Reconciliación',
              },
            ],
          },
          {
            title: 'Consulta pagos',
            children: [
              {
                path: '/admin/bancos/datos-maestros/pago-recibidos',
                title: 'Pagos recibidos',
              },
              {
                path: '/admin/bancos/datos-maestros/pagos-efectuados',
                title: 'Pagos efectuados',
              },
              {
                path: '/admin/bancos/datos-maestros/cuenta-corriente',
                title: 'Cuenta Corriente',
              },
            ],
          },
        ],
      },

      //movil
      {
        title: 'Móvil',
        icon: PhoneAndroid,
        children: [
          {
            title: 'Seguimiento',
            children: [
              {
                path: '/admin/movil/seguimiento/vendedor',
                title: 'Vendedor',
              },
              {
                path: '/admin/movil/seguimiento/marca',
                title: 'Marca',
              },
            ],
          },
          {
            path: '/admin/movil/clientes',
            title: 'Cliente',
          },
          {
            path: '/admin/movil/puntos',
            title: 'Ubicaciones',
          },
          {
            path: '/admin/movil/punto-dia',
            title: 'Puntos del día',
          },
          /* {
            path: '/admin/movil/logueos',
            title: 'Logueos'
          } */
        ],
      },
      {
        title: 'Reparto',
        icon: LocalShipping,
        children: [
          {
            title: 'Operaciones',
            children: [
              {
                path: '/admin/reparto/operaciones/programacion',
                title: 'Programación',
              },
              {
                path: '/admin/reparto/operaciones/configuracion',
                title: 'Configuración Programación',
              },
              {
                path: '/admin/reparto/operaciones/jefe-jornada',
                title: 'Jornada Jefe',
              },
              {
                path: '/admin/reparto/operaciones/cancel-liquidation-day',
                title: 'Cancelar jornada de liquidación',
              },
              {
                path: '/admin/reparto/operaciones/avance-reparto',
                title: 'Distribución',
              },
              {
                path: '/admin/reparto/operaciones/liquidacion',
                title: 'Liquidación',
              },
            ],
          },
          {
            title: 'Datos Maestros',
            children: [
              {
                path: '/admin/reparto/datos-maestros/personal-distribucion',
                title: 'Personal Distribution',
              },
              {
                path: '/admin/reparto/datos-maestros/estado-empleado',
                title: 'Estado Empleado',
              },
              {
                path: '/admin/reparto/datos-maestros/posicion-empleado',
                title: 'Posición Empleado',
              },
              {
                path: '/admin/reparto/datos-maestros/vehiculo',
                title: 'Vehículo',
              },
            ],
          },
          {
            title: 'Consultas',
            children: [
              {
                path: '/admin/reparto/consultas/avance-facturacion',
                title: 'Avc. Facturación',
              },
              {
                path: '/admin/reparto/consultas/avance-liquidacion',
                title: 'Avc. Liquidación',
              },
            ],
          },
        ],
      },
      {
        title: 'Jornadas',
        icon: Event,
        children: [
          {
            path: '/admin/jornadas/jornada-diarias',
            title: 'Jornadas',
          },
          {
            path: '/admin/jornadas/cierre-jornada',
            title: 'Cierre Jornada',
          },
        ],
      },
      {
        title: 'Cuotas',
        icon: LocalAtm,
        children: [
          {
            title: 'Datos maestros',
            children: [
              {
                title: 'Cuotas  ',
                path: '/admin/cuotas/datos-maestros/cuota',
              },
              {
                title: 'Cuotas por zonal',
                path: '/admin/cuotas/datos-maestros/zonal',
              },
            ],
          },
        ],
      },
      {
        title: 'Comisiones',
        icon: MonetizationOn,
        children: [
          {
            title: 'Datos maestros',
            children: [
              {
                path: '/admin/comisiones/datos-maestros/rango',
                title: 'Rango',
              },
              {
                path: '/admin/comisiones/datos-maestros/cuota-zona',
                title: 'Básico',
              },
              {
                path: '/admin/comisiones/datos-maestros/grupo-proveedor',
                title: 'Grupo Proveedor',
              },
            ],
          },
          {
            title: 'Operaciones',
            children: [
              {
                path: '/admin/comisiones/operaciones/incentivo',
                title: 'Incentivos',
              },
            ],
          },
        ],
      },
      {
        title: 'Reportes',
        icon: Assessment,
        children: [
          {
            path: '/admin/reportes/ventas-ruta',
            title: 'Ventas por ruta',
          },
          {
            title: 'Reportes por WhatsApp',
            children: [
              {
                path: '/admin/reportes/whatsapp/actividad',
                title: 'Actividades',
              },
              {
                path: '/admin/reportes/whatsapp/archivo-reporte',
                title: 'Archivos para reporte',
              },
              {
                path: '/admin/reportes/whatsapp/contacto',
                title: 'Contactos WhatsApp',
              },
            ],
          },
        ],
      },
      {
        title: 'Modulo impresión',
        icon: Print,
        children: [
          {
            path: '/admin/impresion/usuarios',
            title: 'Usuarios',
          },
          {
            path: '/admin/impresion/guia-remision',
            title: 'Guía remisión',
          },
        ],
      },
      {
        title: 'Utilitarios',
        icon: Print,
        children: [
          {
            path: '/admin/utility/scan',
            title: 'Escaneo',
          },
        ],
      },
      {
        title: 'Configuración',
        icon: Settings,
        children: [
          {
            path: '/admin/configuracion/usuarios',
            title: 'Usuarios',
          },
          {
            path: '/admin/configuracion/notificaciones',
            title: 'Notificaciones',
          },
          {
            path: '/admin/configuracion/roles',
            title: 'Roles',
          },
          {
            path: '/admin/configuracion/feriado',
            title: 'Feriado',
          },
          {
            path: '/admin/configuracion/variable',
            title: 'Variables',
          },
          {
            path: '/admin/configuracion/aplicaciones-movil',
            title: 'Aplicaciones móviles',
          },
          {
            path: '/admin/configuracion/colores',
            title: 'Colores del aplicativo',
          },
        ],
      },
    ],
  },
];

export default sidebarConfig;
